import { arcPath, polar } from './geometry.js';

/** Brand mark: the ring of the display with its marker. */
export function BrandMark({ className }: { className?: string }) {
  const m = polar(12, 12, 8.2, 81);
  return (
    <svg
      className={className ? `brand-mark ${className}` : 'brand-mark'}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path className="brand-mark-track" d={arcPath(12, 12, 8.2, -135, 135)} />
      <path className="brand-mark-value" d={arcPath(12, 12, 8.2, -135, 81)} />
      <circle className="brand-mark-dot" cx={m.x} cy={m.y} r={2.1} />
    </svg>
  );
}

/** Line drawing of the Quick Mill Orione 3000 with the round display (pairing, empty states). */
export function MachineArt({ className }: { className?: string }) {
  return (
    <svg
      className={className ? `machine-art ${className}` : 'machine-art'}
      viewBox="0 0 160 142"
      aria-hidden="true"
      focusable="false"
    >
      <path className="art-line" d="M42 9h76" />
      <rect className="art-body" x="30" y="14" width="100" height="94" rx="11" />
      <circle className="art-display" cx="80" cy="43" r="18" />
      <path className="art-display-track" d={arcPath(80, 43, 12.5, -135, 135)} />
      <path className="art-display-value" d={arcPath(80, 43, 12.5, -135, 90)} />
      <circle className="art-line" cx="45" cy="30" r="3.2" />
      <circle className="art-line" cx="45" cy="43" r="3.2" />
      <circle className="art-line" cx="45" cy="56" r="3.2" />
      <rect className="art-body" x="60" y="70" width="40" height="10" rx="3.5" />
      <path className="art-body" d="M63 80h34l-4 8H67z" />
      <path className="art-line" d="M97 83.5h28a4 4 0 0 1 0 8H97" />
      <path className="art-line" d="M76 89v4M84 89v4" />
      <path className="art-body" d="M68 97h24v5a7 7 0 0 1-7 7H75a7 7 0 0 1-7-7z" />
      <rect className="art-body" x="24" y="110" width="112" height="11" rx="4.5" />
      <path className="art-line" d="M38 121v8M122 121v8" />
    </svg>
  );
}

/**
 * The round display in pairing mode, as a hint where the code is. The QR symbol is a drawn glyph, not a real
 * code; the code is a placeholder pattern.
 */
export function DisplayHint({ label, className }: { label: string; className?: string }) {
  return (
    <svg
      className={className ? `display-hint ${className}` : 'display-hint'}
      viewBox="0 0 240 240"
      aria-hidden="true"
      focusable="false"
    >
      <circle className="dh-bg" cx="120" cy="120" r="120" />
      <path className="dh-track" d={arcPath(120, 120, 111, -135, 135)} />
      <text className="dh-label" x="120" y="56">
        {label}
      </text>
      <rect className="dh-qr-bg" x="82" y="68" width="76" height="76" rx="8" />
      <g className="dh-qr">
        <rect x="90" y="76" width="20" height="20" rx="3" />
        <rect x="130" y="76" width="20" height="20" rx="3" />
        <rect x="90" y="116" width="20" height="20" rx="3" />
        <rect x="124" y="114" width="8" height="8" rx="1.5" />
        <rect x="138" y="120" width="8" height="8" rx="1.5" />
        <rect x="126" y="130" width="8" height="8" rx="1.5" />
        <rect x="142" y="134" width="8" height="8" rx="1.5" />
      </g>
      <g className="dh-holes">
        <rect x="95" y="81" width="10" height="10" rx="1.5" />
        <rect x="135" y="81" width="10" height="10" rx="1.5" />
        <rect x="95" y="121" width="10" height="10" rx="1.5" />
      </g>
      <text className="dh-code" x="120" y="182">
        XXXX–XXXX
      </text>
    </svg>
  );
}
